import { ReactElement } from "react";

interface TemplateStepProps {
  busy: boolean;
  disabled: boolean;
  onDownload: () => void;
}

/** Step 1 — hand operations the workbook they are meant to fill in. */
const TemplateStep: React.FC<TemplateStepProps> = ({
  busy,
  disabled,
  onDownload,
}): ReactElement => (
  <div className="panel">
    <header>
      <h4>
        <span className="step">1</span>Download the template
      </h4>
    </header>
    <div className="body">
      <div className="template-row">
        <p>
          The workbook contains a <strong>Records</strong> worksheet to fill in
          and an <strong>Instructions</strong> worksheet describing every column
          and accepted value. Do not rename or reorder the headers.
        </p>
        <button
          type="button"
          className="btn primary"
          disabled={disabled}
          onClick={onDownload}
        >
          {busy ? "Preparing…" : "Download template"}
        </button>
      </div>
    </div>
  </div>
);

export default TemplateStep;
